// updaters/PdarsUpdater.ts
import type { Map as MapType } from "maplibre-gl";
import type { MapUpdater, UpdaterContext } from "./types";

// 🌟 FIX: Standardized folder resolution path to single 'pdar' layout syntax

import type { PdarPayload } from "../types/pdar";
import type { PdarsManager } from "../managers/pdars/PdarsManager";

export class PdarsUpdater implements MapUpdater {
  readonly name = "pdars";
  readonly topics = ["pdar", "pdar:batch", "pdar:remove"];

  private pdarsManager: PdarsManager | null = null;

  constructor(private ctx: UpdaterContext) {}

  async initialise(map: MapType) {
    console.log("[PdarsUpdater] Initializing...");
  }

  // Called by MapEngine after PdarsManager is created
  setPdarsManager(manager: PdarsManager) {
    this.pdarsManager = manager;
    console.log("[PdarsUpdater] PdarsManager connected");
  }

  async handleMessage(topic: string, payload: any) {
    switch (topic) {
      case "pdar":
        this.handleUpdate(payload as PdarPayload);
        break;

      case "pdar:batch":
        this.handleBatchUpdate(payload as PdarPayload[]);
        break;

      case "pdar:remove":
        // 🌟 FIX: Safeguard removal messages using your unique pdar identifier key
        if (payload && payload.pdar_id) {
          this.handleRemove(payload.pdar_id);
        }
        break;
    }
  }

  private handleUpdate(payload: PdarPayload) {
    // 🌟 FIX: Safety fallback check to prevent app-level crashes during race conditions
    if (!this.pdarsManager) {
      console.warn(
        "[PdarsUpdater] Deferring incoming stream message: PdarsManager is not attached yet.",
      );
      return;
    }

    // Platform is optional: a payload carrying only targets/pdars is valid and
    // renders the sensors + AoAs without a platform icon. Only drop empty payloads.
    if (!payload) return;

    this.pdarsManager.updatePdarBatch(payload);
  }

  private async handleBatchUpdate(payloads: PdarPayload[]) {
    if (!this.pdarsManager || !Array.isArray(payloads)) return;

    // Unroll incoming payload arrays and feed them sequentially into the pipeline
    for (const singlePayload of payloads) {
      this.handleUpdate(singlePayload);
    }
  }

  private handleRemove(pdarId: string) {
    if (this.pdarsManager) {
      this.pdarsManager.removePdar(pdarId);
    }
  }

  destroy() {
    this.pdarsManager = null;
  }
}
